import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M564.706 1581.176H338.824V338.823h1242.353v225.882h-112.942v-112.94H451.765v1016.47h112.941v112.941zM0 0h1242.353v225.882h-112.941V112.941H112.941v1016.471h112.941v112.94H0V0zm1636.515 1247h142.5v514.632c0 87.354-71.03 158.383-158.383 158.383h-641.25c-87.353 0-158.382-71.03-158.382-158.383V1247h142.5v-233.493C963.5 827.937 1114.492 677 1300.007 677c185.514 0 336.508 150.938 336.508 336.507V1247zm-570-233.493V1247H1533.5v-233.493c0-128.713-104.779-233.492-233.493-233.492-128.713 0-233.492 104.779-233.492 233.492z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconBlueprintLockSolid =
/*#__PURE__*/
function (_Component) {
  _inherits(IconBlueprintLockSolid, _Component);

  function IconBlueprintLockSolid() {
    _classCallCheck(this, IconBlueprintLockSolid);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconBlueprintLockSolid).apply(this, arguments));
  }

  _createClass(IconBlueprintLockSolid, [{
    key: "render",
    value: function render() {
      return React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconBlueprintLock",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconBlueprintLockSolid.displayName = "IconBlueprintLockSolid";
  return IconBlueprintLockSolid;
}(Component);

IconBlueprintLockSolid.glyphName = 'blueprint-lock';
IconBlueprintLockSolid.variant = 'Solid';
IconBlueprintLockSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconBlueprintLockSolid;
export { IconBlueprintLockSolid };